/**
 * Get styles for order status option
 * @param {Object} option - Option object with value
 * @param {boolean} isDarkMode - Whether dark mode is enabled
 * @returns {Object} Style object with backgroundColor and color
 */
export const getOrderStatusStyles = (option, isDarkMode) => {
    // Guard against undefined/null option or value
    if (!option || !option.value) {
        return {
            backgroundColor: isDarkMode ? "#21262d" : "#f5f5f5",
            color: isDarkMode ? "#b1bac4" : "#525252",
            fontWeight: "700",
            fontSize: "14px"
        };
    }

    let backgroundColor = "";
    let color = "";

    if (isDarkMode) {
        switch (option.value) {
            case "REQUESTED":
                backgroundColor = "#21262d";
                color = "#b1bac4";
                break;
            case "PREPARING":
                backgroundColor = "#2a2a2a";
                color = "#b1bac4";
                break;
            case "READY_FOR_DELIVERY":
                backgroundColor = "#2a2a2a";
                color = "#b1bac4";
                break;
            case "DELIVERY_IN_PROGRESS":
                backgroundColor = "#2a2a2a";
                color = "#b1bac4";
                break;
            case "DECLINED":
                backgroundColor = "#2a2a2a";
                color = "#b1bac4";
                break;
            case "DELIVERED":
                backgroundColor = "#2a2a2a";
                color = "#b1bac4";
                break;
            default:
                backgroundColor = "#21262d";
                color = "#b1bac4";
        }
    } else {
        switch (option.value) {
            case "REQUESTED":
                backgroundColor = "#f5f5f5";
                color = "#525252";
                break;
            case "PREPARING":
                backgroundColor = "#f5f5f5";
                color = "#525252";
                break;
            case "READY_FOR_DELIVERY":
                backgroundColor = "#f5f5f5";
                color = "#525252";
                break;
            case "DELIVERY_IN_PROGRESS":
                backgroundColor = "#f5f5f5";
                color = "#525252";
                break;
            case "DECLINED":
                backgroundColor = "#f5f5f5";
                color = "#525252";
                break;
            case "DELIVERED":
                backgroundColor = "#f5f5f5";
                color = "#525252";
                break;
            default:
                backgroundColor = "#f5f5f5";
                color = "#525252";
        }
    }

    return {
        backgroundColor,
        color,
        fontWeight: "700",
        fontSize: "14px"
    };
};

